import { handleActions } from "redux-actions";
import { CATALOG } from "constants/action-types";
import { IBaseStoreState, progressActions } from "reducers/base-reducers";
import { IRequestDataAction } from "epics/base-epic";

export type IImportCatalogRequest = IRequestDataAction<FormData & { url: string }>;

export interface IImportCatalogResponse {
    message: string;
    localizedMessage: string;
    errors?: string[]; // partial success
}

export interface IImportCatalogPayload {
    message: string;
    errors?: string[];
}

export interface IImportCatalogState extends IBaseStoreState<IImportCatalogPayload> {
    isImporting: boolean;
}

const INITIAL_STATE = { isImporting: false, error: null, payload: null };

export const catalogImport = handleActions<IImportCatalogState, IImportCatalogPayload>(
    {
        ...progressActions<IImportCatalogPayload, IImportCatalogState>(CATALOG.IMPORT, "isImporting"),
        [CATALOG.IMPORT.RESET_STATE]: () => ({ ...INITIAL_STATE }),
    } as any,
    { ...INITIAL_STATE }
);
